import React, { type PropsWithChildren } from 'react';

import { Navigate } from 'react-router-dom';

import { Box, CircularProgress } from '@mui/material';

import { isDailyBoardEnabled } from './featureFlag';

type Props = PropsWithChildren<{
  user: Parameters<typeof isDailyBoardEnabled>[0];
  isLoading: boolean;
}>;

export default function DailyBoardRouteGate({ user, isLoading, children }: Props) {
  if (isLoading || !user) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return isDailyBoardEnabled(user) ? <>{children}</> : <Navigate to="/commercial-ops" replace />;
}
